// Product Video Autoplay Enhancement for LCY London
(function() {
  'use strict';

  // Function to setup video autoplay
  function setupVideoAutoplay() {
    // Find all product videos - including those in deferred media
    const productVideos = document.querySelectorAll('.product__media video, deferred-media video, .deferred-media video');
    
    productVideos.forEach(video => {
      setupSingleVideo(video);
    });
  }
  
  // Setup individual video
  function setupSingleVideo(video) {
    // Remove controls and setup autoplay
    video.controls = false;
    video.removeAttribute('controls');
    video.muted = true; // MUST be muted for autoplay
    video.setAttribute('muted', 'muted');
    video.setAttribute('autoplay', 'autoplay');
    video.setAttribute('loop', 'loop');
    video.setAttribute('playsinline', 'playsinline');
    video.setAttribute('webkit-playsinline', 'webkit-playsinline');
    video.setAttribute('preload', 'auto');
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    
    // Add custom styling class
    video.classList.add('product-video-autoplay');
    
    // Remove click handlers that might interfere
    video.onclick = null;
    video.style.pointerEvents = 'none';
    
    // Force play the video
    const playVideo = () => {
      if (video.paused) {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            video.muted = true;
            video.play().catch(() => {});
          });
        }
      }
    };
    
    // Try to play immediately
    playVideo();
    
    // Ensure video plays when it comes into view
    if ('IntersectionObserver' in window) {
      const videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            playVideo();
          } else {
            entry.target.pause();
          }
        });
      }, {
        threshold: 0.3 // Video needs to be 30% visible
      });
      
      videoObserver.observe(video);
    }
    
    // Handle Swiper slide changes
    const swiperContainer = video.closest('.swiper');
    if (swiperContainer && swiperContainer.swiper) {
      swiperContainer.swiper.on('slideChange', function() {
        // Pause all videos
        document.querySelectorAll('.product__media video').forEach(v => v.pause());
        
        // Play video in active slide
        const activeSlide = this.slides[this.activeIndex];
        const activeVideo = activeSlide.querySelector('video');
        if (activeVideo) {
          setupSingleVideo(activeVideo);
          activeVideo.play().catch(() => {});
        }
      });
    }
  }
  
  // Function to handle deferred media (videos loaded after page load)
  function handleDeferredMedia() {
    const deferredMediaElements = document.querySelectorAll('deferred-media');
    
    deferredMediaElements.forEach(element => {
      // Check if already has video loaded
      const existingVideo = element.querySelector('video');
      if (existingVideo) {
        setupSingleVideo(existingVideo);
      }
      
      // Override the loadContent method to setup video after loading
      const originalLoadContent = element.loadContent;
      if (originalLoadContent) {
        element.loadContent = function() {
          originalLoadContent.call(this);
          setTimeout(() => {
            const video = this.querySelector('video');
            if (video) {
              setupSingleVideo(video);
            }
          }, 100);
        };
      }
      
      // Auto-click the play button to load the video
      const playButton = element.querySelector('#Deferred-Poster-Modal-' + element.dataset.mediaId);
      if (playButton && !element.getAttribute('loaded')) {
        // Simulate click to load the video
        playButton.click();
      }
    });
  }
  
  // Function to continuously check for videos
  function continuousVideoCheck() {
    // Check every 500ms for new videos
    setInterval(() => {
      const videos = document.querySelectorAll('video:not(.product-video-autoplay)');
      videos.forEach(video => {
        setupSingleVideo(video);
      });
    }, 500);
  }
  
  // Initialize on DOM content loaded
  document.addEventListener('DOMContentLoaded', function() {
    setupVideoAutoplay();
    handleDeferredMedia();
    continuousVideoCheck(); // Start continuous checking
    
    // Also try after a delay to catch any late-loading videos
    setTimeout(() => {
      setupVideoAutoplay();
      handleDeferredMedia();
    }, 1000);
  });
  
  // Re-initialize on Shopify section load (theme editor)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(() => {
      setupVideoAutoplay();
      handleDeferredMedia();
    }, 100);
  });
  
  // Also run immediately if DOM is already loaded
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    setupVideoAutoplay();
    handleDeferredMedia();
    continuousVideoCheck();
  }
  
  // Handle dynamic content updates
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) { // Element node
            if (node.tagName === 'VIDEO' || node.querySelector?.('video')) {
              setupVideoAutoplay();
            }
          }
        });
      }
    });
  });
  
  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();